import { FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../../components/Flex";
import Input from "../../../../../../../../../../../components/Input";
import Text from "../../../../../../../../../../../components/Text";
import { Form2Payload } from "../../../../../../../../scheduling/appointment/encounter/encounter-constant";
import { PROGRESS_RECOMMENDATION_OPTIONS } from "./ProgressNoteConstant";

interface ProgressNoteRecommendationProps {
  formik: FormikProps<Form2Payload>;
}

/**
 * Recommendation — the single recommendation for the session plus the
 * prescribed frequency of treatment.
 *
 * Both fields are written straight onto the note rather than through the
 * add-button → draft modal → summary flow the other Progress Note blocks use:
 * there are only two of them and the frequency is free text, so a modal would
 * hide more than it helps.
 */
const ProgressNoteRecommendation = ({
  formik,
}: ProgressNoteRecommendationProps) => {
  return (
    <Flex flexDirection="column" gap={1} width="100%">
      <RadioGroup
        name="recommendation"
        value={formik.values?.recommendation ?? ""}
        onChange={(_, value) => formik.setFieldValue("recommendation", value)}
      >
        <Grid container spacing={0.5}>
          {PROGRESS_RECOMMENDATION_OPTIONS.map((option) => (
            <Grid item xs={12} key={option.value}>
              <FormControlLabel
                value={option.value}
                control={<Radio size="small" />}
                sx={{ alignItems: "center" }}
                label={
                  <Text fontSize="14px" fontWeight="500">
                    {option.label}
                  </Text>
                }
              />
            </Grid>
          ))}
        </Grid>
      </RadioGroup>

      <Grid container>
        <Grid item xs={12}>
          <Text fontSize="14px" fontWeight="bold" mb={0.5}>
            Prescribed Frequency of Treatment
          </Text>
          <Input
            textFieldProps={{
              name: "prescribedTreatmentFrequency",
              placeholder: "e.g. Weekly · 50-minute sessions",
              value: formik.values?.prescribedTreatmentFrequency ?? "",
              onChange: formik.handleChange,
              onBlur: formik.handleBlur,
            }}
          />
        </Grid>
      </Grid>
    </Flex>
  );
};

export default ProgressNoteRecommendation;
